import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel.js';
import CityModel from './CityModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/core/users';

export default new class UserModel {

  constructor() { }

  getAll() {
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: this.getAccessToken()
        }
      })
        .then((response) => {
          Promise.all([CityModel.getAll(true), ParkinglocationModel.getAll(true)])
            .then((r) => {
              let cities = r[0];
              let parkingLocations = r[1];

              let newUsers = [];
              response.data.map((user) => {
                let newCities = [];
                let newLocations = [];
                if (user.cities || user.cities !== undefined) {
                  user.cities.map((cityId) => {
                    if (cityId != '*') {
                      let tCity = _.find(cities, { id: cityId });
                      if (!tCity || tCity === undefined) {
                        newCities.push({ id: cityId, name: "Neznámá lokalita" })
                      } else {
                        newCities.push({ id: cityId, name: tCity.code + ' - ' + tCity.name })
                      }
                    } else {
                      newCities.push({ id: cityId, name: cityId });
                    }
                  })
                  user.citiesNames = newCities;
                }
                if (user.locations || user.locations !== undefined) {
                  user.locations.map((locationId) => {
                    if (locationId != '*') {
                      let tLocation = _.find(parkingLocations, { id: locationId });
                      if (!tLocation || tLocation === undefined) {
                        newLocations.push({ id: locationId, name: "Neznámá lokalita" })
                      } else {
                        newLocations.push({ id: locationId, name: tLocation.Code + ' - ' + tLocation.Name })
                      }
                    } else {
                      newLocations.push({ id: locationId, name: locationId });
                    }
                  });
                  user.locationsNames = newLocations;
                }
                newUsers.push(user);
              });
              resolve(newUsers);
            })
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  login(credentials, grant_type = 'password') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        axios.post(BASE + '/login', Object.assign({}, credentials, { grant_type: grant_type }))
          .then(r => {
            let decodedJwt = JSON.parse(Buffer.from(r.data.access_token.split('.')[1], 'base64').toString('utf8'));
            localStorage.setItem('user', JSON.stringify({
              // name: decodedJwt.name,
              // username: decodedJwt.username,
              // roles: decodedJwt.roles,
              expiration: decodedJwt.exp,
              access_token: r.data.access_token,
              refresh_token: r.data.refresh_token
            }));
            resolve(JSON.parse(localStorage.getItem('user')));
          })
          .catch(err => {
            reject(err);
          });
      }, 1000);
    });
  }

  logout() {
    localStorage.clear();
  }

  isAuthenticated() {
    if (!localStorage.getItem('user')) {
      return false;
    }

    if (this.isTokenExpired(this.getAccessToken())) {
      this.logout();
      return false;
    } else {
      return true;
    }

    // NEW
    // if (this.isTokenExpired(this.getAccessToken())) {
    //   if (this.isTokenExpired(this.getRefreshToken())) {
    //     this.logout();
    //     return false;
    //   } else {
    //     return this.login({refresh_token: this.getRefreshToken()}, 'refresh_token')
    //       .then(() => {
    //         return true;
    //       });
    //   }

    // } else {
    //   return true;
    // }

    // OLD
    // let user = JSON.parse(localStorage.getItem('user'));

    // if (!user && !user.expiration) {
    //   localStorage.removeItem('user');
    //   return false;
    // }

    // if (user.expiration <= (Date.now() / 1000)) {
    //   localStorage.removeItem('user');
    //   return false;
    // }
    // return true;
  }

  getUser() {
    if (this.isAuthenticated()) {
      let decodedJwt = JSON.parse(Buffer.from(JSON.parse(localStorage.getItem('user')).access_token.split('.')[1], 'base64').toString('utf8'));
      return decodedJwt;
    } else {
      return null;
    }
  }

  getRoles() {
    if (this.isAuthenticated()) {
      return this.getUser().roles
        ? this.getUser().roles
        : null;
    } else {
      return [];
    }
  }

  isInRoles(roles) {
    let userRoles = this.getRoles();
    if (_.intersectionWith(userRoles, roles, _.isEqual).length > 0) {
      return true;
    } else {
      return false
    }
  }

  getId() {
    if (this.isAuthenticated()) {
      return this.getUser().uid
        ? this.getUser().uid
        : null;
    } else {
      return null;
    }
  }

  getName() {
    if (this.isAuthenticated()) {
      return this.getUser().name
        ? this.getUser().name
        : null;
    } else {
      return null;
    }
  }

  getUsername() {
    if (this.isAuthenticated()) {
      return this.getUser().username
        ? this.getUser().username
        : null;
    } else {
      return null;
    }
  }

  getAccessToken() {
    return JSON.parse(localStorage.getItem('user')).access_token;
  }

  getRefreshToken() {
    return JSON.parse(localStorage.getItem('user')).refresh_token;
  }

  isTokenExpired(token) {
    let decoded = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('utf8'));

    if (!decoded.exp) {
      return true;
    }

    if (decoded.exp <= (Date.now() / 1000)) {
      return true;
    } else {
      return false;
    }
  }

  isUsernameExist(username) {
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: this.getAccessToken(),
          filter: {
            where: {
              username: username
            }
          }
        }
      })
        .then(r => {
          resolve(r.data.length > 0 ? true : false);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: this.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  patch(id, data) {
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + id, data, {
        params: {
          access_token: this.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: this.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  changePassword(oldPassword, newPassword) {
    return new Promise((resolve, reject) => {
      axios.post(BASE + '/' + this.getId() + '/change-password', {
        old_password: oldPassword,
        new_password: newPassword
      }, {
        params: {
          access_token: this.getAccessToken()
        }
      })
        .then((response) => {
          resolve('Heslo bylo změněno!');
        })
        .catch((error) => {
          if (error.response.data.error.code && error.response.data.error.code === 'INVALID_OLD_PASSWORD') {
            reject('Stávající heslo není správné!');
          }

          reject('Nastala neočekávaná chyba při ukládání změny!');
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/UserModel.js